var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.alerts.length)?_c('div',_vm._l((_vm.alerts),function(alert,index){return _c('gl-alert',{key:alert.id,attrs:{"variant":alert.variant,"title":alert.title,"dismissible":alert.dismissible},on:{"dismiss":function($event){return _vm.onDismiss(index)}}},[_vm._v(_vm._s(alert.message))])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }